export const heroContent = {
  title: '优质国货，品质生活',
  subtitle: '汇聚国内顶尖品牌，精选高性价比国产好物',
  ctaText: '探索国货精选',
  ctaLink: '/category',
};

export const categories = [
  {
    id: 'meizhuang',
    name: '国产美妆',
    icon: 'ri-magic-line',
    description: '国内美妆品牌崛起，品质媲美国际大牌，成分安全、价格亲民。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20domestic%20skincare%20and%20cosmetic%20products%20arranged%20elegantly%20on%20a%20clean%20marble%20surface%20with%20soft%20natural%20lighting%2C%20minimalist%20aesthetic%2C%20warm%20cream%20background%2C%20editorial%20product%20photography&width=800&height=600&seq=cat-meizhuang-01&orientation=landscape',
    count: 128,
  },
  {
    id: 'shuma',
    name: '国产数码',
    icon: 'ri-smartphone-line',
    description: '国产手机、耳机、智能穿戴等数码产品，技术创新引领全球。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20tech%20gadgets%20including%20smartphone%20smartwatch%20and%20wireless%20earbuds%20displayed%20on%20a%20minimalist%20wooden%20desk%2C%20soft%20warm%20lighting%2C%20clean%20product%20photography%20with%20cream%20background&width=800&height=600&seq=cat-shuma-01&orientation=landscape',
    count: 96,
  },
  {
    id: 'shipin',
    name: '国产食品',
    icon: 'ri-bowl-line',
    description: '从传统零食到健康食品，国产食品以品质和口味赢得消费者信赖。',
    image: 'https://readdy.ai/api/search-image?query=Assorted%20Chinese%20domestic%20snacks%20and%20health%20foods%20beautifully%20arranged%20on%20a%20rustic%20wooden%20table%2C%20warm%20natural%20light%2C%20food%20photography%20style%20with%20soft%20cream%20background%2C%20elegant%20composition&width=800&height=600&seq=cat-shipin-01&orientation=landscape',
    count: 85,
  },
  {
    id: 'fushi',
    name: '国产服饰',
    icon: 'ri-t-shirt-line',
    description: '国潮设计、原创品牌崛起，国产服饰展现中国设计力量与文化自信。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20domestic%20fashion%20brand%20clothing%20displayed%20on%20minimalist%20wooden%20hangers%20with%20traditional%20elements%20modern%20design%2C%20soft%20studio%20lighting%2C%20cream%20backdrop%2C%20clean%20editorial%20fashion%20photography&width=800&height=600&seq=cat-fushi-01&orientation=landscape',
    count: 112,
  },
];

export const featuredBrands = [
  {
    id: 1,
    name: '花西子',
    category: '国产美妆',
    description: '以东方美学为核心的高端国货彩妆品牌，将中国传统文化与现代彩妆工艺完美融合。',
    logo: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20cosmetic%20brand%20logo%20design%20with%20traditional%20floral%20elements%2C%20minimalist%20aesthetic%2C%20warm%20red%20and%20gold%20tones%2C%20clean%20cream%20background%2C%20flat%20vector%20style&width=200&height=200&seq=brand-huaxizi&orientation=squarish',
    rating: 4.9,
  },
  {
    id: 2,
    name: '华为',
    category: '国产数码',
    description: '全球领先的ICT基础设施和智能终端提供商，以技术创新驱动品质生活。',
    logo: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20technology%20brand%20logo%20design%20with%20geometric%20shapes%2C%20minimalist%20red%20and%20black%20color%20scheme%2C%20clean%20cream%20background%2C%20corporate%20style&width=200&height=200&seq=brand-huawei&orientation=squarish',
    rating: 4.8,
  },
  {
    id: 3,
    name: '三只松鼠',
    category: '国产食品',
    description: '中国互联网坚果零食领导品牌，以新鲜优质的产品和有趣的品牌形象深受年轻消费者喜爱。',
    logo: 'https://readdy.ai/api/search-image?query=Cute%20Chinese%20snack%20food%20brand%20logo%20design%20with%20playful%20animal%20character%2C%20warm%20orange%20tones%2C%20clean%20cream%20background%2C%20flat%20illustration%20style&width=200&height=200&seq=brand-sanzhisongshu&orientation=squarish',
    rating: 4.7,
  },
  {
    id: 4,
    name: '李宁',
    category: '国产服饰',
    description: '中国领先的体育品牌，融合东方文化与现代运动科技，引领国潮风尚。',
    logo: 'https://readdy.ai/api/search-image?query=Chinese%20sportswear%20brand%20logo%20design%20with%20dynamic%20abstract%20shapes%2C%20minimalist%20red%20and%20white%20color%20scheme%2C%20clean%20cream%20background%2C%20modern%20corporate%20style&width=200&height=200&seq=brand-lining&orientation=squarish',
    rating: 4.8,
  },
  {
    id: 5,
    name: '完美日记',
    category: '国产美妆',
    description: '新生代国货彩妆品牌，以高品质、高性价比和时尚设计赢得Z世代消费者的心。',
    logo: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20beauty%20brand%20logo%20design%20with%20elegant%20script%20typography%2C%20minimalist%20pink%20and%20gold%20tones%2C%20clean%20cream%20background%2C%20luxury%20cosmetic%20brand%20style&width=200&height=200&seq=brand-wanmeiriji&orientation=squarish',
    rating: 4.7,
  },
  {
    id: 6,
    name: '小米',
    category: '国产数码',
    description: '以智能手机、智能硬件和IoT平台为核心的互联网科技公司，让每个人都能享受科技乐趣。',
    logo: 'https://readdy.ai/api/search-image?query=Simple%20Chinese%20technology%20brand%20logo%20design%20with%20minimalist%20geometric%20design%2C%20orange%20and%20white%20color%20scheme%2C%20clean%20cream%20background%2C%20corporate%20identity%20style&width=200&height=200&seq=brand-xiaomi&orientation=squarish',
    rating: 4.8,
  },
];

export const latestArticles = [
  {
    id: 1,
    title: '2025年国产美妆品牌TOP10排行榜，谁是真正的国货之光？',
    excerpt: '随着国货美妆品牌的崛起，越来越多的消费者开始关注国产化妆品。我们梳理了2025年最值得关注的十大国产美妆品牌，从产品力、口碑、创新等多个维度进行深度评测。',
    category: '国产美妆',
    categorySlug: 'meizhuang',
    image: 'https://readdy.ai/api/search-image?query=Top%2010%20Chinese%20domestic%20beauty%20brand%20products%20elegantly%20displayed%20on%20a%20minimalist%20white%20shelf%20with%20soft%20warm%20lighting%2C%20editorial%20product%20photography%2C%20clean%20cream%20background%2C%20professional%20composition&width=800&height=500&seq=article-meizhuang-top10&orientation=landscape',
    date: '2025-08-01',
    readTime: '8分钟',
    views: 12580,
  },
  {
    id: 2,
    title: '国产手机崛起：从追随者到领跑者的蜕变之路',
    excerpt: '从华为到小米，从OPPO到vivo，国产手机品牌已经在全球市场占据了重要地位。本文深度解析国产手机品牌如何通过技术创新和品牌建设实现弯道超车。',
    category: '国产数码',
    categorySlug: 'shuma',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20smartphone%20brands%20evolution%20timeline%20displayed%20creatively%20on%20a%20clean%20minimalist%20background%2C%20modern%20tech%20aesthetic%2C%20warm%20cream%20tones%2C%20editorial%20design&width=800&height=500&seq=article-shuma-rise&orientation=landscape',
    date: '2025-07-28',
    readTime: '10分钟',
    views: 9870,
  },
  {
    id: 3,
    title: '国潮新食尚：这些国产零食品牌正在重新定义中国味道',
    excerpt: '三只松鼠、良品铺子、百草味……国产零食品牌正以创新的产品和营销方式，重新定义中国零食市场。本文带你了解国产零食品牌的发展趋势和明星产品。',
    category: '国产食品',
    categorySlug: 'shipin',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20Chinese%20domestic%20snacks%20and%20gourmet%20foods%20beautifully%20arranged%20on%20a%20modern%20wooden%20table%2C%20warm%20lighting%2C%20food%20photography%20style%20with%20soft%20cream%20background&width=800&height=500&seq=article-shipin-trend&orientation=landscape',
    date: '2025-07-25',
    readTime: '7分钟',
    views: 7340,
  },
  {
    id: 4,
    title: '国潮服饰品牌全解析：李宁、安踏们如何让中国设计走向世界',
    excerpt: '从纽约时装周到巴黎时装周，国潮服饰品牌正以独特的设计语言和文化表达征服全球消费者。本文带你全面了解国潮服饰品牌的崛起之路。',
    category: '国产服饰',
    categorySlug: 'fushi',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fashion%20brands%20modern%20clothing%20collection%20displayed%20creatively%20with%20traditional%20Chinese%20elements%2C%20editorial%20fashion%20photography%2C%20warm%20minimalist%20background%2C%20professional%20studio%20lighting&width=800&height=500&seq=article-fushi-guochao&orientation=landscape',
    date: '2025-07-20',
    readTime: '9分钟',
    views: 6120,
  },
  {
    id: 5,
    title: '国产护肤品成分党指南：看懂这些成分，选对国产好货',
    excerpt: '玻尿酸、烟酰胺、视黄醇……国产护肤品牌在成分研发上的投入越来越大。本文为成分党们详细解读国产护肤品中的明星成分和选购技巧。',
    category: '国产美妆',
    categorySlug: 'meizhuang',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20skincare%20products%20with%20ingredient%20labels%20displayed%20scientifically%20on%20a%20clean%20minimalist%20surface%2C%20soft%20natural%20light%2C%20cream%20background%2C%20educational%20product%20photography&width=800&height=500&seq=article-meizhuang-ingredients&orientation=landscape',
    date: '2025-07-15',
    readTime: '12分钟',
    views: 15230,
  },
  {
    id: 6,
    title: '智能穿戴设备选购指南：国产手表和手环哪个更适合你？',
    excerpt: '华为Watch、小米手环、OPPO Watch……国产智能穿戴设备选择越来越丰富。本文帮你分析不同产品的优缺点，找到最适合你的智能穿戴设备。',
    category: '国产数码',
    categorySlug: 'shuma',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20smartwatches%20and%20fitness%20bands%20displayed%20elegantly%20on%20a%20minimalist%20wooden%20surface%2C%20modern%20tech%20aesthetic%2C%20warm%20cream%20background%2C%20product%20photography&width=800&height=500&seq=article-shuma-wearable&orientation=landscape',
    date: '2025-07-10',
    readTime: '8分钟',
    views: 5890,
  },
];

export const whyChoose = [
  {
    icon: 'ri-shield-check-line',
    title: '品质保障',
    description: '每一款推荐国货均经过严格筛选和真实评测，确保产品品质可靠、安全有保障。',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: '高性价比',
    description: '国货品牌省去品牌溢价，用更亲民的价格提供媲美国际大牌的品质体验。',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: '创新驱动',
    description: '国产企业在技术研发和产品创新上持续投入，不断推出引领行业潮流的优质产品。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '支持国货',
    description: '选择国货不仅是选择好产品，更是支持中国制造、助力民族品牌走向世界。',
  },
];

export const faqItems = [
  {
    question: '国产专区的产品推荐是否有保障？',
    answer: '国产专区的每一款产品推荐都经过我们团队的严格筛选和真实评测。我们建立了完善的选品标准，从产品品质、用户口碑、品牌信誉、性价比等多个维度综合评估，确保推荐的每一款产品都值得信赖。',
  },
  {
    question: '如何判断一款国货产品是否值得购买？',
    answer: '我们建议从以下几个方面综合判断：一是看品牌背景和研发实力，二是查看产品成分和配料表，三是参考真实用户的评价反馈，四是比较同类型产品的性价比。国产专区会为您提供全面的产品分析和选购建议。',
  },
  {
    question: '国产美妆产品的安全性如何？',
    answer: '目前国产美妆产品的监管标准已经非常严格，所有正规上市的美妆产品都需要通过国家药监局的备案和审批。许多国货品牌在产品安全性和成分研发上的投入甚至超过了国际品牌，消费者可以放心选购。',
  },
  {
    question: '国产数码产品的售后服务怎么样？',
    answer: '国内主流数码品牌如华为、小米、OPPO、vivo等都在全国建立了完善的售后服务网络。大部分品牌提供全国联保、上门维修等服务，售后体验已经不输甚至超越国际品牌。',
  },
  {
    question: '国产专区的内容多久更新一次？',
    answer: '我们的编辑团队每天都会更新最新的国货资讯、产品评测和选购指南。品牌排行榜和推荐清单每月更新，确保内容始终反映最新的市场动态和产品信息。',
  },
];

export const stats = [
  { value: '500+', label: '精选品牌' },
  { value: '2000+', label: '评测文章' },
  { value: '50万+', label: '月活用户' },
  { value: '98%', label: '用户好评率' },
];